export const CSharedValues = {
    SEND_MONEY_PATH: 'send-money',
    SEND_MONEY_WALLET: 'sendMoneyWallet'
} as const;